<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<h4>Edit a {{partnerTypeShort}}</h4>

@if (partnerType === 'Brand') {
The Brand Client is the entity whose message content is being sent to wireless subscribers. 
}
@else {
  The Content Provider is the entity that provides the message content.
}
On this page, you can update information about a {{partnerTypeWithSpace}}. Some updates may result in a re-vet of the {{partnerTypeWithSpace}}.

<form #form1="ngForm" (keydown.enter)="handleEnter($event)">
  <div *ngIf="isDisplay">

    <div class="row mt-4">
      <div class="col-12 mb-2">
        <strong>{{partnerTypeShort}} ID: </strong>{{model.partnerId}}
      </div>
      <div class="col-12 mb-2">
        @if (partnerType === 'Brand') {
        <strong>Associated Short Codes: </strong>
        <span *ngFor="let scId of allScIds; let last=last">
          <span>{{scId}}</span>
          <span *ngIf="!last">, </span>
        </span>
      }
      @else {
        <strong># of Associated Short Codes: </strong>{{scIdCount}}
      }
      </div>
      <div class="col-12 mb-2">
        <strong>Vet Status Updated: </strong>{{model.vetStatusUpdateTime | date: 'M/d/yyyy'}}
      </div>
      <div class="col-12 mb-2">
        <strong>Current Vet Status: </strong>{{model.vetStatus}} {{model.vetStatusReason}}
      </div>
      <div class="col-12 mb-2">
        <div class="row">
          <div class="col-1"><strong>Vet Results: </strong></div>
          @if (model.vetResults) {
          <div class="col-11">
            @if (model.vetStatus === 'Successful' || model.vetStatus === 'Unsuccessful' || model.vetStatus === 'Incomplete' || model.vetStatus === 'Pending') {
              @for(finding of model.vetResults.findings; track finding;) {
                <p class="compress">{{finding}}</p>
              }
            }
            @else if (model.vetResults.errorDescription) {
              {{model.vetResults.errorDescription}}
            }
            @else {
              n/a
            }
          </div>
        }
        @else {
          n/a
        }
        </div>
      </div>
    </div>
    <ng-template #companyInfoTooltipContent>

      This section allows you to enter information to identify the {{partnerTypeWithSpace}} organization.
      This includes:<p>
      <ul class="list-unstyled">
        <li><strong>Organization Name: </strong>enter the legal Organization Name associated with the {{partnerTypeWithSpace}}'s Federal Tax ID</li>
        <li><strong>Legal Entity Type: </strong>select or enter the business structure the {{partnerTypeWithSpace}} organization operates under financially</li>
        <li><strong>Doing Business As: </strong>if the {{partnerTypeWithSpace}} organization conducts business under any other names, indicate those here</li>
        <li><strong>Country of Registration: </strong>enter the Country in which the {{partnerTypeWithSpace}} organization is registered. If it's registered in the United States, you may
          indicate the state in which it is registered</li>
        <li><strong>Stock Market Symbol: </strong>the {{partnerTypeWithSpace}} organization's stock market symbol, if it is publicly traded</li>
        <li><strong>URL: </strong>the {{partnerTypeWithSpace}} organization's web address</li>
        <li><strong>Federal Tax ID: </strong>the {{partnerTypeWithSpace}} organization's Federal Employer ID Number or FEIN (Format: ##-#######)</li>
        <li><strong>Dun &amp; Bradstreet: </strong>the {{partnerTypeWithSpace}} organization's DUNS (Format: 9 digits)</li>
        <li><strong>GIIN: </strong>the {{partnerTypeWithSpace}} organization's Global Intermediary Identification Number, if one has been assigned (Format: XXXXXX.XXXXX.XX.XXX)</li>
        <li><strong>LEI: </strong>the {{partnerTypeWithSpace}} organization's Legal Entity Identifier (Format: 20 characters)</li>
        @if (partnerType === 'Brand') {
        <li><strong>Subsidiaries & Legal Affiliates: </strong>enter any subsidiaries and/or legal affiliates of the {{partnerTypeWithSpace}} organization that are expected
          to use short codes for messaging. Max allowed: 50</li>
        }
      </ul>
      <p></p>
      Typically the {{partnerTypeWithSpace}} organization's accounting department will have this information.<br />
      Please contact support at {{customerSupportPhone}} if you need assistance.


    </ng-template>

    <h5 class="mt-4 ">
      {{partnerTypeWithSpace}} Organization Information
      <sup>
        <i class="fa fa-circle-info small" style="color: #004381; margin-left: .1em;" [pTooltip]="companyInfoTooltipContent"></i>
      </sup>
    </h5>
    <div class="row mt-4">

      <div class="row">
        <div class="col-6 mb-3">
          <label for="company" class="required">Organization Name</label>
          <input appScrText [(ngModel)]="model.company" name="company" id="company" #company="ngModel" [required]="true" placeholder="Legal Organization Name Associated with FEIN"
            maxlength="{{MaxLen.Company}}" />
          <app-error-msg [form]="form1" [field]="company" fieldLabel="Organization Name"></app-error-msg>
        </div>
        <div class="mb-3 col-md-4">
          <label for="legalEntityType" class="required">Legal Entity Type</label>
          <p-dropdown [editable]="true" appDd placeholder="Enter or Select" maxlength="{{MaxLen.legalEntityType}}" [options]="legalEntityTypes" [required]="true"
          id="legalEntityType" name="legalEntityType" #legalEntityType="ngModel" [(ngModel)]="model.legalEntityType" (onChange)="onChangeDropdown($event)"></p-dropdown>
          <app-error-msg [field]="legalEntityType" fieldLabel="Legal Entity Type"></app-error-msg>
        </div>
      </div>

      <div class="row">
        <div class="col-6 mb-3">
          <label for="dba" class="col-12">Doing Business As</label>
          <input appScrText #dba="ngModel" [(ngModel)]="model.dba" name="dba" id="dba" placeholder="Doing Business As" maxlength="80" />
          <app-error-msg [field]="dba" fieldLabel="dba"></app-error-msg>
        </div>
        <div class="mb-3 col-md-4">
          <label for="registration" class="col-8 required">Country of Registration</label>
          <div class="col-12">
            <input appScrText #registration="ngModel" [required]="true" [(ngModel)]="model.registration" name="registration" id="registration" placeholder="Country of Registration"
              maxlength="50" />
            <app-error-msg [field]="registration" fieldLabel="Country of Registration"></app-error-msg>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-5 mb-3">
          <label for="companySymbol">Stock Market Symbol</label>
          <input appScrText appUppercase [(ngModel)]="model.companySymbol" name="companySymbol" id="companySymbol" #companySymbol="ngModel" mask="AAAAA" pattern=".*[A-Za-z].*"
            [validation]="false" placeholder="Stock Market Symbol" />
          <div>
            <ng-template [ngIf]="companySymbol.dirty && companySymbol.invalid && !companySymbol.errors?.required">
              <span class="failed">
                must be between 1 and 5 alphanumeric characters
              </span>
            </ng-template>
          </div>
        </div>
        <div class="col-5 mb-3">
          <label for="companyUrl" class="required">URL</label>
          <input appScrText appUrlValidator [(ngModel)]="model.companyUrl" name="companyUrl" id="companyUrl" #companyUrl="ngModel" placeholder="Website URL"
            maxlength="{{MaxLen.CompanyUrl}}" required autocomplete="url" />
          <app-error-msg [form]="form1" [field]="companyUrl" fieldLabel="Website URL"></app-error-msg>
        </div>

      </div>
      <div class="row">
        <div class="col-5 mb-3">
          <label for="fein" class="required">Federal Tax ID (##-#######)</label>
          <input appScrText [(ngModel)]="model.fein" #fein="ngModel" name="fein" id="fein" mask="00-0000000" [dropSpecialCharacters]="false" placeholder="**-*******" required />
          <app-error-msg [form]="form1" [field]="fein" fieldLabel="Federal Tax ID"></app-error-msg>
        </div>
        <div class="col-5 mb-3">
          <label for="duns">Dun & Bradstreet (DUNS) 9 Digits</label>
          <input appScrText [(ngModel)]="model.duns" name="duns" id="duns" #duns="ngModel" mask="000000000" placeholder="9 Digits" />
          <app-error-msg [form]="form1" [field]="duns" fieldLabel="DUNS"></app-error-msg>
        </div>
      </div>

      <div class="row">
        <div class="col-5 mb-3">
          <label for="giin" class="col-12">GIIN (XXXXXX.XXXXX.XX.XXX)</label>
          <input appUppercase appScrText #giin="ngModel" [(ngModel)]="model.giin" name="giin" id="giin" placeholder="GIIN" maxlength="19" mask="AAAAAA.AAAAA.AA.000"
            [dropSpecialCharacters]="false" pattern="[A-NP-Z\d]{6}\.[A-NP-Z\d]{5}\.(LE|SL|ME|BR|SP|SF|SD|SS|SB)\.\d{3}" [validation]="false" />
          <app-error-msg [field]="giin" fieldLabel="GIIN"></app-error-msg>
        </div>
        <div class="col-5 mb-3">
          <label for="lei" class="col-8">LEI (20 Characters)</label>
          <div class="col-12">
            <input appUppercase appLei appScrText #lei="ngModel" [(ngModel)]="model.lei" name="lei" id="lei" placeholder="LEI" maxlength="20" pattern="[A-Z\d]{18}\d{2}" />
            <app-error-msg [field]="lei" fieldLabel="LEI"></app-error-msg>
          </div>
        </div>
      </div>
      <div class="row last-element">
        @if (partnerType === 'Brand') {
        <div class="col-10">
          <label for="relatedNames">Subsidiaries & Legal Affiliates</label>
          <p-chips appChips delimiter='^' class="d-block" #subsidiaries='ngModel' [max]="50" name="subsidiaries" inputId="subsidiariesInput" id="subsidiaries"
            [(ngModel)]="model.subsidiaries" (onAdd)="validateChipFormat($event)" [allowDuplicate]="false" placeholder='Brand Client Subsidiaries or Legal Affiliates that will be using short codes for messaging' [addOnBlur]="true"></p-chips>
            <div class="help-text">Press the Enter key between each entry.</div>
        </div>
        }
      </div>
      <hr />
      <h5 class="mt-2">
        {{partnerTypeWithSpace}} Street Address
      </h5>
      <div class="row mt-4">
        <div class="col-4 mb-3">
          <label for="country" class="required">Country </label>
          <app-country-dropdown [(ngModel)]="model.country" name="country" #country="ngModel" id="country" appTid>
          </app-country-dropdown>
          <app-error-msg [form]="form1" [field]="country" fieldLabel="Country"></app-error-msg>
        </div>
      </div>
      <div class="row">
        <div class="col-10 mb-3">
          <label for="address1" class="required">Street Address 1 </label>
          <input appScrText [(ngModel)]="model.address1" #address1="ngModel" name="address1" id="address1" placeholder="Street Address" maxlength="{{MaxLen.Address}}" required
            autocomplete="billing address-line1" />
          <app-error-msg [form]="form1" [field]="address1" fieldLabel="Street Address 1"></app-error-msg>
        </div>
      </div>
      <div class="row">
        <div class="col-10 mb-3">
          <label for="address2">Street Address 2 </label>
          <input appScrText [(ngModel)]="model.address2" name="address2" id="address2" placeholder="Street Address 2" autocomplete="billing address-line2"
            maxlength="{{MaxLen.Address}}" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 mb-3">
          <label for="city" class="required">City </label>
          <input appScrText [(ngModel)]="model.city" #city="ngModel" name="city" id="city" placeholder="City" autocomplete="billing address-line2" maxlength="{{MaxLen.City}}"
            required />
          <app-error-msg [form]="form1" [field]="city" fieldLabel="City"></app-error-msg>
        </div>
        <div class="col-3 mb-3">
          <label for="state" [ngClass]="{required: model.country === 'ca' || model.country === 'us'}">State/Province</label>
          <app-region-dropdown name="state" id="state" appTid autocomplete="billing address-level1" [(ngModel)]="model.state" #state="ngModel" [country]="model.country">
          </app-region-dropdown>
          <app-error-msg [form]="form1" [field]="state" fieldLabel="State/Province"></app-error-msg>

        </div>
        <div class="col-3 mb-3">
          <label for="zipInput" [ngClass]="{required: model.country === 'us' || model.country === 'ca'}">Zip/Postal
            Code</label>
          <app-zipcode-input name="zip" id="zip" inputId="zipInput" [(ngModel)]="model.zip" [country]="model.country" #zipModel="ngModel">
          </app-zipcode-input>

          <app-error-msg [form]="form1" [field]="zipModel" fieldLabel="Zip/Postal Code"></app-error-msg>
        </div>
      </div>
      <hr />
      <h5 class="mt-2">
        {{partnerTypeWithSpace}} Point of Contact
      </h5>
      <div class="row mt-4">
        <div class="col-4 mb-3">
          <label for="firstName" class="required">First Name </label>
          <input appScrText appFirstNameValidator [(ngModel)]="model.firstName" #firstName="ngModel" name="firstName" autocomplete="given-name" id="firstName"
            placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />
          <app-error-msg [form]="form1" [field]="firstName" fieldLabel="First Name"></app-error-msg>
        </div>

        <div class="col-4 mb-3">
          <label for="lastName" class="required">Last Name </label>
          <input appScrText appLastNameValidator [(ngModel)]="model.lastName" #lastName="ngModel" name="lastName" autocomplete="family-name" id="lastName" placeholder="Last Name"
            maxlength="{{MaxLen.LastName}}" required />
          <app-error-msg [form]="form1" [field]="lastName" fieldLabel="Last Name"></app-error-msg>
        </div>
      </div>

      <div class="row">
        <div class="col-3 mb-3">
          <label for="phoneInput" class="required">Phone Number</label>
          <app-phone [(ngModel)]="model.phone" #phone="ngModel" class="col-12" name="phone" required id="phone" autocomplete="tel"></app-phone>
          <app-error-msg [form]="form1" [field]="phone" fieldLabel="Phone Number"></app-error-msg>
        </div>
        <div class="col-2 ps-0">
          <label for="extension">Extension</label>
          <input appScrText [(ngModel)]="model.phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="phoneExtension" autocomplete="tel-extension" id="extension"
            placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col-6 mb-3">
          <label for="email" class="required">Email </label>
          <input appEmail appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [(ngModel)]="model.email" name="email" id="email" #email="ngModel"
            autocomplete="email" maxlength="{{MaxLen.Email}}" placeholder="Email" required />
          <app-error-msg [form]="form1" [field]="email" fieldLabel="Email"></app-error-msg>
        </div>
      </div>



      <div class="d-flex justify-content-start mt-3">
        <button (click)="updatePartner(form1)" class="btn btn-primary me-4">Update {{partnerTypeShort}}</button>
        <button class="btn btn-secondary" type="button" (click)="confirmCancelDialog()">Cancel</button>
      </div>
    </div>
  </div>
</form>
<p-confirmDialog key='confirmCancel' #updatePartnerFormCancel width="425" [closable]="false">
  <p-footer>
    <div class="d-flex justify-content-end">
      <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="updatePartnerFormCancel.accept()">Yes</button>
      <button i18n id="screject" class="btn btn-secondary" type="button" (click)="updatePartnerFormCancel.reject()">No</button>
    </div>
  </p-footer>
</p-confirmDialog>